import { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import PublicProfile from "../views/PublicProfile";

const RouteProtected = ({ isLoggedIn, children }) => {
  const location = useLocation();
  const { id } = useParams();

  useEffect(() => {}, [location.pathname, id]);

  if (isLoggedIn === undefined) {
    return (
      <div className="spinner-loader">
        <div className="spinner"></div>
      </div>
    );
  }
  const isSpecificRoute = location.pathname === `/${id}`;

  if (!isLoggedIn && isSpecificRoute) {
    return <PublicProfile id={id} />;
  }
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default RouteProtected;
